import { render } from "./EditClass.vue?vue&type=template&id=68fd4a3c&ts=true"
import script from "./EditClass.vue?vue&type=script&lang=ts"
export * from "./EditClass.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__